import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Lore } from "@/components/Lore";
import { DatBih } from "@/components/DatBih";
import { TikTokWall } from "@/components/TikTokWall";
import { Footer } from "@/components/Footer";
import { BG_URL } from "@/lib/constants";

const Home = () => {
  useEffect(() => {
    // blue translucent filter over the collage background — light enough to keep black text readable
    const overlay =
      "linear-gradient(rgba(180,210,255,0.78), rgba(180,210,255,0.78))";
    document.body.style.backgroundImage = `${overlay}, url("${BG_URL}")`;
    document.body.style.backgroundSize = "auto, cover";
    document.body.style.backgroundPosition = "center, center";
    document.body.style.backgroundRepeat = "repeat, no-repeat";
    document.body.style.backgroundAttachment = "fixed, fixed";
    return () => {
      document.body.style.backgroundImage = "";
    };
  }, []);

  return (
    <div data-testid="home-root">

      <Nav />
      <Hero />

      <Marquee
        items={[
          "$DATBIHGAH",
          "DAT BIH GAH",
          "DAT BIH TUH",
          "SAY IT LOUD",
          "STILL EARLY",
          "ON SOLANA",
        ]}
        variant="red"
      />

      <Lore />

      <Marquee
        items={[
          "DAT BIH TUH · DAT BIH GAH",
          "PRESS IT",
          "FEEL IT",
          "POST IT",
        ]}
        variant="black"
        speed="fast"
      />

      <DatBih />

      <Marquee
        items={[
          "VIRAL ON TIKTOK",
          "VIRAL ON X",
          "AND COUNTING",
          "$DATBIHGAH",
        ]}
        variant="red"
        speed="fast"
      />

      <TikTokWall />
      <Footer />

      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#fff",
            color: "#000",
            border: "3px solid #000",
            boxShadow: "6px 6px 0 #000",
            fontFamily: "LuckiestGuy, sans-serif",
            letterSpacing: "0.04em",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
